export const PREVIEW_AUTH_TOKEN = "preview-auth-token";

export function isPreviewAuthEnabled() {
  return import.meta.env.VITE_PREVIEW_AUTH === "true";
}

export function isPreviewAuthToken(token) {
  return token === PREVIEW_AUTH_TOKEN;
}

export function createPreviewUser(email) {
  const localPart = email.split("@")[0]?.trim();
  return {
    id: "preview-user",
    email,
    name: localPart || "Preview User",
    role: "performer",
    credits: 10,
  };
}
